import { store } from '../store'
import waitForAuthReady from './wait-for-auth'

// Guards the alarms & notifications page, which every signed-in user can open:
// the notifications tab is for everyone, while the page itself only shows the
// alarm tabs (and only loads alarms) for users with the alarms feature enabled
// on at least one device (premium plans).
export default async (to, from, next) => {
  // Wait for Firebase to restore the persisted session before deciding, so a
  // hard refresh on this deep link doesn't redirect an authenticated user.
  await waitForAuthReady()

  if (!store.getters.user) {
    next({ path: '/signin', query: { redirect: to.fullPath } })
    return
  }

  next()
}



// WEBPACK FOOTER //
// ./src/router/alarms-guard.js